<template>
  <v-layout>
    <v-flex xs12 sm6 offset-sm3>
      <v-flex xs12 md44 class="my-3">

    <div class="text-xs-center">
      <h2 class="headline">招待状を送りましょう</h2>
      <p>友達にチームへの招待状を送って、メンバー追加しましょう。</p>
    </div>
  </v-flex>

<div style="text-align: center;">
<div id="sendline-btn" class="line-it-button" data-lang="ja" data-type="share-a" v-bind:data-url="customurl" style="display: none;"></div>
</div>
<v-btn block secondary green v-on:click="sendmail()">メールで送る</v-btn>

<div id="fb-root"></div>
  <!-- Your send button code -->
  <div class="fb-send" 
    data-href="https://www.your-domain.com/your-page.html" 
    data-layout="button_count">
  </div>

    </v-flex>
  </v-layout>
</template>


<script>

import firebase from 'firebase'
import LineIt from 'LineIt'

export default {
  components: {
    firebase,
    LineIt
  },
  data () {
    return {
      customurl: ''
    }
  },
  mounted () {
    LineIt.loadButton()
  },
  created () {
    this.makeurl()
  },
  methods: {
    makeurl: function () {
      this.customurl = 'https://' + location.hostname + '/#/team/join?t=' + this.$route.params.id
    },
    sendmail: function () {
      let user = firebase.auth().currentUser
      let subject = 'バスケットボールチームへの招待'
      let body = user.displayName + 'さんからバスケットボールチームへのご招待です。%0d%0aURLをクリックしてJOINしてください。%0d%0a%0d%0a'
      let bodyurl = this.customurl

      // ドメイン
      // mailto:?subject=チームへの招待&body=ご感想を%0D%0Aお願いします。
      document.location = 'mailto:' + '?subject=' + subject + '&body=' + body + bodyurl
    }
  },
  computed: {
//    LineIt.loadButton()
  }
}
</script>

<style>
.ggmap {
position: relative;
padding-bottom: 56.25%;
padding-top: 30px;
height: 0;
overflow: hidden;
}
 
.ggmap iframe,
.ggmap object,
.ggmap embed {
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/team/Invite.vue